import { all, call, put, takeLatest } from 'redux-saga/effects';
import Moment from 'moment';
import envConfig from '../../../config';

import { fetchEntityChangeLog } from '../../routines';
import constants from '../../../common/constants/CommonConstants';
import { request } from '../../../common/util/RestClient';
import { ENTITY_CHANGE_LOG_PAGE_SIZE } from '../../../common/constants/EntityChangeLogConstants';

const { ORGANIZATION_LEVEL, ACCOUNT_LEVEL, CONTACT_LEVEL, PIPELINE_LEVEL } =
  constants;
function formatFilters(filters) {
  return filters.reduce((acc, filter) => {
    const {
      attribute: { name: attribute },
      value,
      filter: operator,
    } = filter;

    const returnObj = {
      name: attribute,
      operator,
      value,
    };

    switch (attribute) {
      case 'date': {
        switch (operator) {
          case 'equals': {
            const startOfDay = Moment(value[0])
              .startOf('day')
              .utc()
              .toISOString();
            const endOfDay = Moment(value[0]).endOf('day').utc().toISOString();

            returnObj.operator = 'between';
            returnObj.value = [startOfDay, endOfDay];
            break;
          }
          case 'greater': {
            const endOfDay = Moment(value[0]).endOf('day').utc().toISOString();

            returnObj.operator = 'after';
            returnObj.value = endOfDay;
            break;
          }
          case 'greaterEqual': {
            const after = Moment(value[0]).startOf('day').utc().toISOString(); // start of because that day is also counted (equal part)

            returnObj.operator = 'onOrAfter';
            returnObj.value = after;
            break;
          }
          case 'lesser': {
            const before = Moment(value[0]).startOf('day').utc().toISOString();

            returnObj.operator = 'before';
            returnObj.value = before;
            break;
          }
          case 'lesserEqual': {
            const before = Moment(value[0]).endOf('day').utc().toISOString(); // end of because that day is also counted (equal part)

            returnObj.operator = 'onOrBefore';
            returnObj.value = before;
            break;
          }
          case 'between': {
            const rangeStart = Moment(value[0])
              .startOf('day')
              .utc()
              .toISOString();

            const rangeEnd = Moment(value[1]).endOf('day').utc().toISOString();

            returnObj.value = [rangeStart, rangeEnd];
            break;
          }
          default:
            break;
        }
        break;
      }
      default:
        break;
    }

    return [...acc, returnObj];
  }, []);
}

export function getChangeLogApiHelper(payload = {}) {
  const { level, entityId, filters, cursor } = payload;
  const options = {
    method: 'POST',
    payload: {
      level,
      entityId: +entityId,
      cursor,
      ...(filters && filters.length > 0
        ? { filters: formatFilters(filters) }
        : {}),
    },
  };

  const url = `${envConfig.APIG_URL}core/entity/change-log`;
  return request(url, options);
}

export function* fetchChangeLogSaga({ payload }) {
  const { level, entityId, preservePreviousList } = payload;
  const supportedLevels = [
    ORGANIZATION_LEVEL,
    ACCOUNT_LEVEL,
    CONTACT_LEVEL,
    PIPELINE_LEVEL,
  ];
  try {
    if (!supportedLevels.includes(level)) {
      yield put(
        fetchEntityChangeLog.failure({
          error: {
            message: 'Invalid level',
          },
        })
      );
      return;
    }
    if (!entityId) {
      yield put(
        fetchEntityChangeLog.failure({
          error: {
            message: 'Invalid entity id',
          },
        })
      );
      return;
    }
    const response = yield call(getChangeLogApiHelper, payload);
    yield put(
      fetchEntityChangeLog.success({
        log: response.data,
        level,
        cursor:
          response?.totalResponseCount === ENTITY_CHANGE_LOG_PAGE_SIZE
            ? Moment(
                response.data[response.data.length - 1].changedAt
              ).toISOString()
            : null,
        preservePreviousList,
      })
    );
  } catch (error) {
    yield put(fetchEntityChangeLog.failure({ error, level }));
  } finally {
    yield put(fetchEntityChangeLog.fulfill());
  }
}

export default function* root() {
  yield all([takeLatest(fetchEntityChangeLog.TRIGGER, fetchChangeLogSaga)]);
}
